import type { SxProps, Theme } from '@mui/material/styles'

/** Figma `37:1094` — row kebab dropdown shell. */
export const signalProviderRowActionsMenuPaperSx: SxProps<Theme> = {
  mt: 0.5,
  borderRadius: '10px',
  border: '0.5px solid #e0e5eb',
  bgcolor: '#ffffff',
  boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.2)',
  minWidth: 157,
  overflow: 'hidden',
  '& .MuiList-root': {
    py: 0,
  },
}

/** Figma `37:1094` — destructive menu action label. */
export const signalProviderDeactivateMenuItemSx: SxProps<Theme> = {
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  letterSpacing: '-0.1504px',
  color: '#ef4444',
  minHeight: 31,
  px: '20px',
  py: '6px',
  justifyContent: 'flex-start',
  '&:hover': {
    bgcolor: '#f8fafc',
  },
}

/** US-SPL-1-24 — reactivate menu item (green text, same shell). */
export const signalProviderReactivateMenuItemSx: SxProps<Theme> = {
  ...signalProviderDeactivateMenuItemSx,
  color: '#008236',
}
